import { request } from '@/services/request/request.api'

import {
	IHighlightJob,
	IHighlightJobStatus,
	ILanguage,
	IListeners,
	IRenameTaskRequest,
	ITask,
	ITaskSearchRequest,
	ITaskSearchResponse,
	ITranscriptions,
	IUploadHighlightRequest
} from '@/types/task.interface'

export const TasksService = {
	async getListeners() {
		return request<IListeners>({
			url: '/listeners',
			method: 'GET'
		})
	},
	async getTasks() {
		return request<ITask[]>({
			url: '/tasks',
			method: 'GET'
		})
	},
	async getTask(id: string) {
		return request<ITask>({
			url: `/tasks/${id}`,
			method: 'GET'
		})
	},
	async getTranscriptions(id: string, startAfter?: number) {
		return request<ITranscriptions>({
			url: `/tasks/${id}/transcriptions/chunks`,
			method: 'GET',
			params:
				typeof startAfter === 'number' ? { start_after: startAfter } : undefined
		})
	},
	async searchTask({ taskId, q, ...params }: ITaskSearchRequest) {
		return request<ITaskSearchResponse>({
			url: `/tasks/${taskId}/search`,
			method: 'GET',
			params: {
				q,
				mode: 'phrase',
				limit: 1000,
				...params
			}
		})
	},
	async getLanguages() {
		return request<ILanguage[]>({
			url: '/languages',
			method: 'GET'
		})
	},
	async uploadHighlight(data: IUploadHighlightRequest) {
		return request<IHighlightJob>({
			url: `/tasks/${data.id}/highlight`,
			method: 'POST',
			data: {
				ranges: data.range
			}
		})
	},
	async getHighlightJobStatus(taskId: string, jobId: string) {
		return request<IHighlightJobStatus>({
			url: `/tasks/${taskId}/highlight/${jobId}/status`,
			method: 'GET'
		})
	},
	async retryHighlightJob(taskId: string, jobId: string) {
		return request<IHighlightJob>({
			url: `/tasks/${taskId}/highlight/${jobId}/retry`,
			method: 'POST'
		})
	},
	async uploadHighlightsDraft(data: IUploadHighlightRequest) {
		return request<IUploadHighlightRequest>({
			url: `/tasks/${data.id}/highlight-draft`,
			method: 'POST',
			data: {
				ranges: data.range
			}
		})
	},
	async renameTask({ taskId, source }: IRenameTaskRequest) {
		return request<ITask>({
			url: `/tasks/${taskId}/source/change`,
			method: 'POST',
			data: {
				source
			}
		})
	},
	async deleteTask(id: string) {
		return request<ITask>({
			url: `/tasks/${id}`,
			method: 'DELETE'
		})
	},
	async startStopTranscribing(proxy_name: string, blocked: boolean) {
		return request<void>({
			url: '/proxy/control',
			method: 'POST',
			data: {
				proxy_name,
				blocked
			}
		})
	}
}
